export const LOGGING_INIT_ROLLBAR = "LOGGING_INIT_ROLLBAR";
export const LOGGING_INFO = "LOGGING_INFO";
export const LOGGING_ERROR = "LOGGING_ERROR";
